import React from 'react';
import { useUIStore } from '../stores/uiStore';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/auth';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import Tippy from '@tippyjs/react';
import Sidebar from '../components/sidebar/Sidebar';
import ChatContainer from '../components/chat/ChatContainer';
import styles from './ChatPage.module.css';

const ChatPage: React.FC = () => {
  const { isSidebarOpen, setIsSidebarOpen, setActiveSessionId } = useUIStore();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    try {
      await authService.logout();
      queryClient.removeQueries({ queryKey: ['sessions'] });
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const openNewConversation = () => {
    setActiveSessionId(null);
  }

  // Get user initials for avatar
  const getUserInitials = () => {
    if (!currentUser?.email) return '?';
    return currentUser.email.charAt(0).toUpperCase();
  };



  return (
    <div className={`${styles.container} ${!isSidebarOpen ? styles.sidebarHidden : ''}`}>
      <div className={`${styles.sidebar}`}>
        <Sidebar />
      </div>

      <div className={styles.main}>
        <header className={styles.header}>
          <div>
            <button
              className={styles.menuButton}
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
            <Tippy content="New conversation">
              <button
                className={styles.menuButton}
                aria-label='New conversation'
                onClick={openNewConversation}
              >
                <img src='/assets/imgs/new_chat.png' alt='new_conversation'/>
              </button>
            </Tippy>
          </div>

          <div className={styles.userMenu}>
            <div className={styles.userButton}>
              <div className={styles.avatar}>
                {getUserInitials()}
              </div>
              <span className={styles.userName}>
                {currentUser?.email}
              </span>

              <div className={styles.dropdown}>
                <button onClick={handleLogout} className={styles.dropdownItem}>
                  Logout
                </button>
              </div>
            </div>
          </div>
        </header>

        <ChatContainer />
      </div>
    </div>
  );
};

export default ChatPage;